import { Directive, EventEmitter, Input, Output } from '@angular/core';


export class TextDirective {
   newValue = new EventEmitter<any>();
   text: any;

  changeInput(value: string) {
    this.newValue.emit(value);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[text]',
  host    : {
    '(input)': 'changeInput($event.target.value)'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'newValue': [{ type: Output, args: ['newValue', ] },],
'text': [{ type: Input, args: ['text', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
